import { render, staticRenderFns } from "./CadastroComponent.vue?vue&type=template&id=067c9551&scoped=true&"
import script from "@/pages/login/Cadastrar.js?vue&type=script&lang=js&"
export * from "@/pages/login/Cadastrar.js?vue&type=script&lang=js&"
import style0 from "@/components/auth/auth-form.css?vue&type=style&index=0&id=067c9551&scoped=true&lang=css&"
import style1 from "./CadastroComponent.vue?vue&type=style&index=1&id=067c9551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c9551",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VProgressCircular,VSnackbar})
